import React from 'react';
import {
  Box,
  Typography,
  Button,
  AppBar,
  Toolbar,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemText,
  useTheme,
  useMediaQuery,
  Stack,
  alpha
} from '@mui/material';
import {
  Menu as MenuIcon,
  Close as CloseIcon
} from '@mui/icons-material';
import { Link, useNavigate } from 'react-router-dom';
import logo from '../images/MF-Logo1.png';

const AppBarComponent = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const navigate = useNavigate();

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const navItems = [
    { name: 'Home', path: '/' },
    { name: 'Services', path: '/services' },
    { name: 'Projects', path: '/projects' },
    { name: 'About', path: '/about' },
    { name: 'Contact', path: 'mailto:info@maximalflooring.com' }
  ];

  const handleNavClick = (path) => {
    if (path.startsWith('/#')) {
      // Handle anchor links
      const element = document.querySelector(path.substring(1));
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    } else if (path.includes('mailto:')) {
      window.location.href = path;
    } else {
      navigate(path);
    }
    setMobileOpen(false);
  };

  const drawer = (
    <Box onClick={handleDrawerToggle} sx={{ textAlign: 'center' }}>
      <IconButton
        sx={{
          position: 'absolute',
          right: 8,
          top: 8,
          color: 'inherit'
        }}
        onClick={handleDrawerToggle}
      >
        <CloseIcon />
      </IconButton>
      <Box sx={{ my: 2, display: 'flex', justifyContent: 'center' }}>
        <img 
          src={logo} 
          alt="Maximal Construction Logo" 
          style={{ 
            height: '40px',
            width: 'auto'
          }}
        />
      </Box>
      <List>
        {navItems.map((item) => (
          <ListItem key={item.name} onClick={() => handleNavClick(item.path)}>
            <ListItemText primary={item.name} />
          </ListItem>
        ))}
      </List>
    </Box>
  );

  return (
    <>
      <AppBar position="fixed" 
      sx={{ 
        backgroundColor: alpha(theme.palette.background.main, 0.7), 
        backdropFilter: 'blur(20px)',
        color: 'logo.main',
        boxShadow: 'none',
        // transform: 'skew(10deg, 40deg)',
        transition: 'transform 0.3s ease-in-out'
      }}>
        <Toolbar>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Link to="/" style={{ textDecoration: 'none', color: 'inherit' }}>
              <img 
                src={logo} 
                alt="Maximal Construction Logo" 
                style={{ 
                  height: '40px',
                  width: 'auto'
                }}
              />
            </Link>
            <Typography
              variant="h6"
              sx={{
                ml: 2,
                fontFamily: '"Nexa Slab Bold", serif',
                fontWeight: 700,
                letterSpacing: 2,
                fontSize: { xs: '0rem', md: '1.25rem' },
                display: { xs: 'none', md: 'block' },
                cursor: 'pointer'
              }}
              onClick={() => handleNavClick('/')}
            >
              MAXIMAL <span 
              style={{ color: 'white', fontFamily: '"Nexa Slab Regular", serif', fontWeight: 500 }}>FLOORING</span>
            </Typography>
          </Box>
          
          {isMobile ? (
            <IconButton
              color="inherit"
              aria-label="open drawer"
              edge="start"
              onClick={handleDrawerToggle}
              sx={{ ml: 'auto' }}
            >
              <MenuIcon />
            </IconButton>
          ) : (
            <>
              <Box sx={{ flexGrow: 1, display: 'flex', justifyContent: 'center' }}>
                <Stack direction="row" spacing={3}>
                  {navItems.map((item) => (
                    <Button 
                      key={item.name} 
                      sx={{ color: 'white', textTransform: 'none' }}
                      onClick={() => handleNavClick(item.path)}
                    >
                      {item.name}
                    </Button>
                  ))}
                </Stack>
              </Box>
              <Button
                variant="contained"
                sx={{
                  backgroundColor: 'primary.main',
                  color: 'black',
                  fontWeight: 600,
                  px: 3,
                  py: 1,
                  '&:hover': {
                    backgroundColor: 'primary.dark',
                    color: 'white'
                  }
                }}
              >
                Get Quote
              </Button>
            </>
          )}
        </Toolbar>
      </AppBar>

      <Drawer
        variant="temporary"
        open={mobileOpen}
        onClose={handleDrawerToggle}
        ModalProps={{
          keepMounted: true
        }}
        sx={{
          display: { xs: 'block', md: 'none' },
          '& .MuiDrawer-paper': {
            boxSizing: 'border-box',
            width: 240,
            backgroundColor: theme.palette.background.main,
            color: 'white',
            '& .MuiListItemText-primary': {
              color: 'white'
            }
          }
        }}
      >
        {drawer}
      </Drawer>
    </>
  );
};

export default AppBarComponent; 